export default __webpack_public_path__ + "static/media/service-5.0771b87f.svg";